<template>
    <div :class="{'v-select':!btn,'v-btn-select':btn,'v-con':true}"
     :style="{minWidth:width > 1 ? width + 'px' : width}"
      tabindex="0"
     @focus="activate()"
     @blur="searchable ? false : deactivate()">
        <div class="dropdown-toggle" :style="{minHeight:height + 'px',lineHeight:height -2 + 'px'}" :class="{active:show}">
          <template v-if="multiple">
            <span class="tags" v-for="(tag,index) in currentOption" @mousedown.prevent :key="index">
             {tag.name}}
              <i class="del" @click.stop="del(index)">&times;</i>
            </span>
          </template>
          <span v-else>{{currentOption&&!searchable ? (btn?placeholder:currentOption.name) : ''}}</span>
          <input type="text"
          style="max-width:140px;border:0"
          ref="search"
          v-if="searchable"
          autocomplete="off"
          :placeholder="place+$t('components.vselect.input_search')"
          @focus.prevent="activate()"
          @blur.prevent="deactivate()"
          v-model="search">
          <span v-else :style="{'color':btn?'':'#acacac'}">{{place}}</span>
          <i class="arrow"></i>
        </div>
        <transition name="fade">
        <ul ref="menu" class="dropdown-menu" v-show="show"  @blur="show = false">
            <template v-if="options.length">
              <li :class="{active: isSelected(option),'delete':allowDelete && isSelected(option)}"
                  @mousedown.prevent="choose(option,$event)"
                  v-for="(option, idx) in filteredOptions" :key="idx">{{option.name}}</li>
            </template>
            <li v-else class="disabled">{{$t('components.vselect.empty')}}</li>
        </ul>
        </transition>
    </div>
</template>

<script>
  export default {
    name: "VSelect",
    props:{
      btn:{
        type:Boolean,
        default:false
      },
      width:{
        default: 176
      },
      height:{
        default:28
      },
      placeholder:{
        type:String,
      },
      value:{
        type:[String,Number,Boolean,Array]
      },
      options:{
        type:Array,
        default () {
          return []
        }
      },
      multiple:{
        type:Boolean,
        default:false
      },
      valueKey:{
        type:String,
        default:''
      },
      //允许点击已选项,将其删除
      allowDelete:{
        type:Boolean,
        default:false
      },
      searchable:{
        type:Boolean,
        default:false
      },
      //本地筛选
      localSearch:{
        type:Boolean,
        default:false,
      }
    },
    data () {
      return {
        show:false,
        search:'',
        currentOption:this.multiple ? [] : null,
        model:this.value
      }
    },
    computed:{
      filteredOptions () {
        var options = this.options
        if (this.localSearch && this.search != '')
          options = this.options.filter(v => v.name.indexOf(this.search) !== -1)
        return options
      },
      optionKeys () {
        return this.valueKey ? this.options.map(v => v.value[this.valueKey]) : this.options.map(v => v.value)
      },
      place () {
        if (Array.isArray(this.currentOption)) {
          return  this.currentOption.length > 0 ? '' : this.placeholder
        }else{
          return this.currentOption ? '' :this.placeholder
        }
      },
      valueKeys () {
        if (this.valueKey) {
          return this.multiple
            ? this.model.map(v => v[this.valueKey])
            : this.model[this.valueKey]
        } else {
          return this.model
        }
      }
    },
    watch:{
      'search':function () {
        // this.$emit('searchchange', val)
      },
      'value':function (val) {
        this.model = val;
      },
      'model':function (val) {
        this.changeValue ();
        this.$emit('input',val)
        if(!val){this.search=''}
      },
      'options':'changeValue'
    },
    methods:{
      isSelected (option) {
        var opt = this.valueKey ? option.value[this.valueKey] : option.value
        if(this.btn){
          return false
        }
        if (this.multiple) {
          return this.valueKeys.indexOf(opt) > -1
        } else {
          return this.valueKeys === opt
        }
      },
      changeValue () {
        // console.log("value changed"+this.value)
        if (!this.multiple) {
          if (this.model === '') {
            return this.currentOption = null
          }
          for (var i = 0; i < this.options.length; i++) {
            var opt = this.valueKey ? this.options[i].value[this.valueKey] : this.options[i].value
            if (opt === this.valueKeys) {
              return this.currentOption  = this.options[i]
            }
          }
          return this.currentOption = null
        }else{
          if (this.model === []) {
            return this.currentOption = []
          }
          var temp = []
          for (let i = 0; i < this.valueKeys.length; i++) {
            var option = this.currentOption.concat(this.options)
            var optionKeys = this.valueKey ? option.map(v => v.value[this.valueKey]) : option.map(v => v.value)
            var index = optionKeys.indexOf(this.valueKeys[i])
            if (index > -1) {
              temp.push(option[index])
            }
          }
          return this.currentOption = temp
        }
      },
      del(index){
        this.model.splice(index,1)
      },
      choose (option) {
        if (!this.multiple) {
          if (this.allowDelete && this.isSelected(option)) {
            this.model = ''
          }else{
            this.model = option.value
          }
          this.deactivate()
        }else{
          if (this.isSelected(option)){
            if (!this.allowDelete) {
              return
            }else{
              var opt = this.valueKey ? option.value[this.valueKey] : option.value
              var index = this.valueKeys.indexOf(opt)
              this.model.splice(index,1)
            }
          }else{
            this.model.push(option.value)
          }
        }
        this.search = option.name
        this.$emit('sel',option.value)
      },
      activate () {
        if (this.show) return
        this.show = true
        if (this.searchable) {
          this.search = ''
          this.$refs.search.focus()
        } else {
          this.$el.focus()
        }
        this.$emit('open')
      },
      deactivate () {
        if (!this.show) return
        this.show = false
        if (this.searchable) {
          this.$refs.search.blur()
          this.search = ''
        } else {
          this.$el.blur()
        }
      },
    },
    mounted() {
      if (this.multiple && !Array.isArray(this.model)) {
        this.model = []
      }
      this.changeValue ();
    }
  }
</script>

<style lang="less" scoped>
@import '@/assets/css/animation.less';
@import '@/assets/css/varible.less';
.active{
  background: lighten(yellow,45%);
}
.arrow{
  position: absolute;
  right: 10px;
  bottom:40%;
  width: 10px;
  height: 10px;
  transform:rotate(-45deg);
  border-left: 1px solid #555;
  border-bottom: 1px solid #555;
}
.dropdown-toggle{
    cursor: pointer;
    font-size: 14px;
    border:1px solid #acacae;
    padding: 0 24px 0 4px;
    line-height: 26px;
    min-height: 28px;
    input{
      width: auto;
      border:0;
      outline: 0;
      vertical-align: baseline;
      &::-ms-clear {
        display: none;
      }
    }
    span{
      cursor: pointer;
    }
  }
  .dropdown-menu{
    position: absolute;
    left:0;
    right: 0;
    border:1px solid #acacae;
    border-top: 0;
    color:#000;
    background: #fff;
    cursor: pointer;
    outline: none;
    line-height: 1.5;
    z-index: 2;
    max-height: 200px;
    overflow-x: hidden;
    overflow-y: auto;
    li{
      padding-left: 8px;
      line-height: 26px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      &:hover{
        color:#fff;
        background: lighten(@blue,15%);
      }
    }
    li.delete:hover{
      color:#fff;
      background: red;
    }
    li.disabled{
      color:#bfcbd9;
      background: transparent;
      cursor: not-allowed;
    }
    li.active{
      color:#000;
      background: #c3c3c3;
    }
  }
.tags{
    position: relative;
    display: inline-block;
    padding:2px;
    padding-right: 1.5em;
    line-height: 1.5;
    margin:2px;
    border-radius: 4px;
    background-color: #dfdfdf;
    user-select: none;
    max-width: 100px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;
    vertical-align: middle;
  }
.del{
  position: absolute;
  right: 0.5em;
  cursor: pointer;
  color:#c55;
}
.v-con {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  outline: none;
  cursor: pointer;

}
.v-select{
  background: #fff;
}
.v-btn-select{
  min-width: 60px!important;
  .dropdown-toggle{
    .table-button();
    padding-right: 16px!important;
    font-size: 13px;
    .arrow{
      width: 7px;
      height: 7px;
      border-color:#0072c5;
      transform:rotate(-45deg);
    }
  }
  .dropdown-menu{
    font-size: 13px;
    border-radius:4px;
    padding: 5px;
    min-width: 120px;
    left:-60px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.3);
    border: 1px solid #c8cbcc;
    color:#000;
    background: #fefefe;
  }
}
</style>
